import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UserResultModel } from '../../../../models/userResultModel';
import { AdminService } from '../../../../services/admin.service';
import { AddUserComponent } from '../add-user/add-user.component';
import { EditUserComponent } from '../edit-user/edit-user.component';
import { BackOfficeService } from '../../../../services/backoffice.service';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UsersListComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  displayedColumns: string[] = [
    'isApproved',
    'name',
    'email',
    'mobile',
    'smsVerification',
    'accessLevel',
    'roles',
    'lastLogin',
    'created'
  ];
  dataSource: MatTableDataSource<UserResultModel>;
  public users: UserResultModel[] = new Array<UserResultModel>();

  constructor(public adminService: AdminService, public backOfficeService: BackOfficeService, public dialog: MatDialog) { }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnInit() {
    this.backOfficeService.loadUsers().subscribe(result => {
      console.log('LOAD_USERS', result);
      this.users = result.users;
      this.dataSource = new MatTableDataSource(this.users);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  addNewUser() {
    const dialogRef = this.dialog.open(AddUserComponent, {
      width: '350px',
      height: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed', result);
    });
  }

  openEdit(user: UserResultModel) {
    this.dialog.open(EditUserComponent, {
      width: '650px',
      maxHeight: '90vh',
      maxWidth: '95vw',
      data: user
    });
    console.log('EDIT_USER', user);
  }
}
